export class ProfileImage {
  public name: string;
  public url: string;
  public size: string;

  constructor(url = '/assets/images/unknown.png') {
    this.url = url;
  }

}